import * as ACTION_TYPES from './types';

const initialState = {
  data: {},
  isTyping: false,
};
const TYPING = 'typing';
const TYPING_STOP = 'stop_typing';

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.TYPING_EVENT:
      return {
        ...state,
        data: payload.message.data,
        isTyping: payload.message.event === TYPING,
      };
    case ACTION_TYPES.TYPING_EVENT_STOP:
      return {
        ...state,
        isTyping: false,
      };
    default:
      return state;
  }
}
